export const topics = [
  {
    topic: '首页',
    to: '/home',
  },
  {
    topic: '关于智选',
    to: '/about?selected=1',
    title: 'COMPANY PROFILE<br/>公司简介',
    key: 'introduce'
  },
  {
    topic: '公开信息披露',
    to: '/about?selected=2',
    navs: [
      {
        nav: '·Public 公开信息披露·',
        title: 'PUBLIC INFO<br/>公开信息披露',
        key: 'public-info'
      },
      {
        nav: '·资质证书·',
        title: '资质证书',
        key: 'licenses'
      }
    ]
  },
  {
    topic: '宣传栏',
    to: '/about?selected=3',
    title: '智选保代宣传月- 守住钱袋子·护好幸福家',
    key: 'publicity'
  },
  {
    topic: '在线投保',
    to: 'https://order.yhtdbx.com/',
  },
  {
    topic: '隐私政策',
    to: '/term?selected=5',
  },
  {
    topic: '用户协议',
    to: '/term?selected=6',
  }
];